// 上次圖片
import request60 from '@/utils/request60'
import { getToken } from '../utils/auth'
export function updatefile (data) {
  return request60({
    url: '/updatefile',
    method: 'post',
    params: { token: getToken() },
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/upload.js